export function roundNumberToHundredths(number: number): number {
  return Math.round(number * 100) / 100
}

export function convertLoadValue(number: number) {
  // Round the number to hundreds
  return roundNumberToHundredths(number)
}
